import { CodeSystem, ElasticsearchConfig } from '../types'

const environment = process.env.REACT_APP_ENVIRONMENT // dev, stage, prod

const config: ElasticsearchConfig = {
	configVersion: 3,
	codeSystem: CodeSystem.Phbu,
	indexName: `search-ehelse-kodeverk-${environment}-phbu`,
	minimumScore: 15,
	minimumNestedFieldScore: 0,
	maximumNestedFieldValues: 5,
	displayScore: true,
	properties: [
		{
			propertyName: 'code_system',
			displayName: 'Kodeverk',
			weight: 1,
			searchEnabled: false,
			returnInResults: true,
		},
		{
			propertyName: 'name_norwegian',
			displayName: 'Kodetekst',
			weight: 1,
			searchEnabled: true,
			returnInResults: true,
		},
		{
			propertyName: 'name_norwegian.infix',
			displayName: 'Del av kodetekst',
			weight: 1,
			searchEnabled: true,
			returnInResults: false,
		},
		{
			propertyName: 'code',
			weight: 20,
			searchEnabled: true,
			returnInResults: true,
			displayName: 'Kodeverdi',
		},
		{
			propertyName: 'inclusion',
			weight: 2,
			searchEnabled: true,
			returnInResults: true,
			displayName: 'Inklusjoner',
		},
		{
			propertyName: 'notes',
			weight: 2,
			searchEnabled: true,
			returnInResults: true,
			displayName: 'Merknad',
		},
		{
			propertyName: 'code_length',
			weight: 1,
			searchEnabled: false,
			returnInResults: true,
			displayName: 'Kodelengde',
		},
		{
			propertyName: 'additional_atc_code_recommended',
			weight: 1,
			searchEnabled: false,
			returnInResults: true,
			displayName: 'ATC tilleggskode',
		},
		{
			propertyName: 'non_specific_code',
			weight: 1,
			searchEnabled: false,
			returnInResults: true,
			displayName: 'Uspesifikk kode',
		},
		{
			propertyName: 'compact_code',
			weight: 1,
			searchEnabled: true,
			returnInResults: true,
			displayName: 'Kompakt kode',
		},
		{
			propertyName: 'star_code',
			weight: 1,
			searchEnabled: false,
			returnInResults: true,
			displayName: 'Stjernekode',
		},
		{
			propertyName: 'additional_code',
			weight: 1,
			searchEnabled: true,
			returnInResults: true,
			displayName: 'Tilleggskode',
		},
		{
			propertyName: 'reportable_npr',
			weight: 1,
			searchEnabled: true,
			returnInResults: true,
			displayName: 'Rapporteres til NPR',
		},
		{
			propertyName: 'chapter_code',
			weight: 1,
			searchEnabled: false,
			returnInResults: true,
			displayName: 'Akse',
		},
		{
			propertyName: 'active',
			weight: 1,
			searchEnabled: false,
			returnInResults: true,
			displayName: 'Aktiv',
		},
		{
			propertyName: 'status_changed_date',
			weight: 1,
			searchEnabled: false,
			returnInResults: true,
			displayName: 'Aktiv endret dato',
		},
	],
	nestedProperties: [
		{
			propertyName: 'synonyms',
			weight: 1,
			searchEnabled: true,
			returnInResults: true,
			nestedFields: [
				{
					propertyName: 'term',
					weight: 2,
					searchEnabled: true,
					returnInResults: true,
					displayName: 'Term',
				},
				{
					propertyName: 'term.infix',
					weight: 1,
					searchEnabled: true,
					returnInResults: false,
					displayName: 'Del av term',
				},
				{
					propertyName: 'synonym_of_term',
					weight: 1,
					searchEnabled: false,
					returnInResults: true,
					displayName: 'Synonym for',
				},
				{
					propertyName: 'source_system',
					weight: 1,
					searchEnabled: false,
					returnInResults: true,
					displayName: 'Synonymkilde',
				},
				{
					propertyName: 'source_id',
					weight: 1,
					searchEnabled: false,
					returnInResults: true,
					displayName: 'Synonym ID',
				},
			],
			displayName: 'Synonymer',
		},
	],
	facetFields: ['active', 'chapter_code'],
}

export default config
